<template>
	<ion-footer class="footer py-5">
		<div class="container">
			<ion-row>

				<ion-col size="6" size-lg="3">
					<h4>{{$t('Products')}}</h4>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fumbi-index-portfolio')}`">{{$t('Fumbi Index Portfolio')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fumbi-advanced-portfolio')}`">{{$t('Fumbi Advanced Portfolio')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fumbi-staking-portfolio')}`">{{$t('Fumbi Staking Portfolio')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fumbi-customs')}`">{{$t('Fumbi Custom')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fumbi-bitcoin-and-gold')}`">{{$t('Fumbi Bitcoin and Gold')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fumbi-gift-vouchers')}`">{{$t('Gift Vouchers')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fumbi-custody')}`">{{$t('Fumbi Custody')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-fees')}`">{{$t('Fees')}}</a>
				</ion-col>

				<ion-col size="6" size-lg="3">
					<h4>{{$t('About us')}}</h4>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-cryptocurrencies')}`">{{$t('Cryptocurrencies')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-vision')}`">{{$t('Vision')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-performance')}`">{{$t('Performance')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-benefits')}`">{{$t('Benefits')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-security')}`">{{$t('Security')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-dictionary')}`">{{$t('Dictionary')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-team')}`">{{$t('Team')}}</a>
				</ion-col>

				<ion-col size="12" size-sm="6" size-lg="3">
					<h4>{{$t('Information')}}</h4>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-contact')}`">{{$t('Contact us')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-documents')}`">{{$t('Documents')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-warning')}`">{{$t('WARNING')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-payment-methods')}`">{{$t('Payment Methods')}}</a>
					<a target="_blank" :href="`https://fumbi.network/${$w18n.currentLanguage.value.value}/${$t('footer-status')}`">{{$t('Status')}}</a>
					<a href="javascript: Cookiebot.renew()">{{$t('Privacy settings')}}</a>
				</ion-col>

			</ion-row> 

			<hr>

			<ion-row>
				<ion-col class="mb-2" size="12">

					<h4>{{$t('Where to find us')}}</h4>
				</ion-col>

				<ion-col size="6" size-lg="3">
					<p>{{$t('Fumbi Network s.r.o.')}}</p>
					<p>{{$t('Suché mýto 6')}}</p>
					<p>{{$t('811 03 Bratislava')}}</p>
					<p>{{$t('Slovakia')}}</p>
					<p>{{$t('ID: 55651232')}}</p>
				</ion-col>

				<ion-col size="6" size-lg="3">
					<p>{{$t('Fumbi Network j.s.a.')}}</p>
					<p>{{$t('Suché mýto 6')}}</p>
					<p>{{$t('811 03 Bratislava')}}</p>
					<p>{{$t('Slovakia')}}</p>
					<p>{{$t('ID: 52005895')}}</p>
				</ion-col>

				<ion-col size="6" size-lg="3">
					<p>{{$t('FUMBI Wealth Management, a. s.')}}</p>
					<p>{{$t('Suché mýto 6')}}</p>
					<p>{{$t('811 03 Bratislava')}}</p>
					<p>{{$t('Slovakia')}}</p>
					<p>{{$t('ID: 56176660')}}</p>
				</ion-col>

				<ion-col size="6" size-lg="3">
					<p>{{$t('DLT Payments OÜ')}}</p>
					<p>{{$t('Tornimäe 5')}}</p>
					<p>{{$t('10145 Tallin')}}</p>
					<p>{{$t('Republic of Estonia')}}</p>
					<p>{{$t('Registry code: 16546853')}}</p>
				</ion-col>

			</ion-row>

			<hr> 
			
			<div class="copyright d-flex ion-align-items-center">
				<img class="footer-logo" src="./assets/img/fumbi-footer-logo.svg" alt="">
				<p class="disclaimer">© {{ moment().year() }} Fumbi Network j. s. a. All rights reserved.</p>
			</div>
		
		</div>
	</ion-footer>
</template>

<script>
import { logoFacebook, logoTwitter, logoLinkedin } from 'ionicons/icons'
import moment from 'moment'

export default {
	data() {
		return {
			logoFacebook,
			logoTwitter,
			logoLinkedin,
			moment
		}
	},
}
</script>

<style lang="sass" scoped>
.footer
	background: black

	.footer-logo
		height: 45px
		margin-right: 1.5rem

	.socials
		margin-top: 48px

		img
			width: 32px
			display: block
			margin: 0 8px
			transition: transform 0.3s

			&:hover
				transform: scale(1.1)
			
			&.mr-0
				margin-right: 0 !important
			&.ml-0
				margin-left: 0 !important

	ion-col
		margin-bottom: 50px

h4
	color: white
	font-size: 20px
	font-weight: 600
	padding: 8px 0
	margin: 0 0 16px


a,p
	color: white
	font-size: 	14px
	padding: 8px 0
	margin: 0
	font-weight: 600

a
	text-decoration: none
	display: block
	transition: color .3s

	&:hover,
	&:hover ion-icon
		color: var(--ion-color-primary)

	&.warning-link
		display: inline-block
		color: var(--ion-color-primary)
		margin: 0
		padding: 0

hr
	background-color: rgba(255, 255, 255, .3)
	margin: 30px 0

.disclaimer
	margin: 0

@media (max-width: 767px)
	.copyright
		flex-direction: column
		align-items: flex-start !important

@media (max-width: 991px)
	.container
		max-width: 720px

	a,p
		padding: 5px 0

@media (min-width: 992px)
	.text-right-lg
		text-align: right

	.socials
		justify-content: flex-end
	
	ion-col
		margin-bottom: 0 !important

</style>